/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */

/**
 * localhost ip:http://localhost:8000/api/v1/
 * live ip:https://manage.martmax.co/api/v1/
 */
export const environment = {
  production: true,
  apiEndpoint: 'https://manage.martmax.co/api/v1/',
  clientID: 'f3d259ddd3ed8ff3843839b',
  clientSecret: '4c7f6f8fa93d59c45502c0ae8c4a95b'
};



// WEBPACK FOOTER //
// /opt/build/repo/src/environments/environment.ts